import clsx from "clsx";
import { Command, useHotkey } from "./useHotkey";
import React from "react";

export function FloatingMenu({
    children,
    className,
}: {
    children: React.ReactNode;
    className?: string;
}) {
    return (
        <menu
            className={clsx(
                "p-2",
                "bg-[rgba(255,255,255,0.02)]",
                "border border-[rgba(100,116,139,0.12)]",
                "flex cursor-pointer rounded-[10px]",
                "shadow-[0_2px_3px_0_rgba(0,0,0,0.25)]",
                className,
            )}
        >
            {children}
        </menu>
    );
}

export function FloatingMenuCommand({
    icon,
    command,
}: {
    icon: React.ReactNode;
    command: Command;
}) {
    useHotkey({ command });
    return (
        <div className="tt-trigger group">
            <button
                type="button"
                className={clsx(
                    "xs h-5 w-9 p-0",
                    "quiet flex cursor-pointer items-center gap-2",
                )}
                onClick={() => command.onClick()}
                role="menuitem"
            >
                {React.cloneElement(icon as React.ReactElement, {
                    className: clsx(
                        "size-5 cursor-pointer stroke-slate-300 group-hover:stroke-white",
                        (icon as React.ReactElement)?.props?.className,
                    ),
                })}
            </button>
            <div className="tt-container tt-bottom rounded-[10px] ring-0">
                <div className="tt flex items-center justify-center">
                    <p className="body-s w-fit whitespace-nowrap text-nowrap">
                        {command.label}
                    </p>
                </div>
            </div>
        </div>
    );
}
